<template>
	<div class="col-12">
		<!--
		<b-input-group class="mt-3">
			<b-form-input v-model="buscar" placeholder="¿Que busca?"></b-form-input>
			<b-input-group-append>
				<b-button v-on:click="getTodos(buscar)" variant="outline-success">Button</b-button>
			</b-input-group-append>
		</b-input-group>
		
		<p v-if="numResult == 1">Se encontró {{ numResult }} resultado en la búsqueda.</p>
		<p v-if="numResult > 1">Se encontraron {{ numResult }} resultados en la búsqueda.</p>
		<p v-if="numResult == 0">No se encontraron resultados en la búsqueda</p>
		-->

		<template v-for="(p, index) in publicaciones">
			<publication :publi="p"></publication>
		</template>
		<!-- <pre>{{$data | json }}</pre> -->
	</div>
</template>

<script>
	import axios from 'axios'
	import configService from '../services/config'
	import Publication from './Publication.vue'

	export default {
		name: 'publications',
		components: { 
			Publication
		},
		data () {
			return {
				publicaciones: null,
				buscar: null,
				numResult: null
			}
		},
		mounted () {
			this.getTodos();
		},
		methods: {
			getTodos (buscar) {
				axios
					.get(configService.apiUrl+'publicaciones/')
					//.get(configService.apiUrl+'publicaciones/'+'?titulo='+buscar)
						.then( response => {
							this.publicaciones = response.data.results,
							this.numResult = response.data.count 
						})
						.catch( e => console.log(e))
			}
		}
	}
</script>




// WEBPACK FOOTER //
// src/components/Publications.vue